import React from 'react';
import './loader.scss'
const Loader = () => {

    return (
        <div className="loader-container">

        </div>
    );
};

export default Loader;